import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';
import { Ic } from './Icon';

const Ctx = createContext<(t: string) => void>(() => {});
export const useToast = () => useContext(Ctx);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [text, setText] = useState('');
  const [on, setOn] = useState(false);
  const t = useRef<ReturnType<typeof setTimeout>>(undefined);
  const toast = useCallback((s: string) => {
    setText(s); setOn(true); clearTimeout(t.current);
    t.current = setTimeout(() => setOn(false), 3200);
  }, []);
  return (
    <Ctx.Provider value={toast}>
      {children}
      <div className={'toast' + (on ? ' on' : '')} role="status"><i><Ic n="check" s="xs" /></i><span>{text}</span></div>
    </Ctx.Provider>
  );
}
